/**
 * Amplify Storage (default access `guest`) already prefixes keys with `public/`.
 * Keys stored in DB must be relative to that prefix (e.g. `therapist-profiles/userId/file.jpg`).
 * If older code saved `public/...`, strip one `public/` so getUrl does not produce `public/public/...`.
 */
export function normalizeProfilePhotoKeyForStorage(storedKey: string): string {
  let k = storedKey.trim();
  while (k.startsWith('public/')) {
    k = k.slice('public/'.length);
  }
  return k;
}

/** Pass this to getUrl({ key }) for keys read from TherapistProfile.profilePhotoKey. */
export function keyForAmplifyGetUrl(storedKey: string | null | undefined): string {
  return normalizeProfilePhotoKeyForStorage(storedKey ?? '');
}
